module.exports = __webpack_public_path__ + "static/media/web_development_banner-min.2f3680ed.png";